module.exports = __webpack_public_path__ + "img/battery-half.706f4d20.svg";